// extracted by mini-css-extract-plugin
module.exports = {"root":"Disabled_root__1Dfoa"};